import { takeLatest, call, put } from 'redux-saga/effects';

import { type SupplierFacility } from '@frontend/api';

import supplierSettingsService from 'services/supplierSettingsService';

import { fetchSupplierFacilities, types } from './actions';

export default function* root() {
  yield takeLatest(
    types.FETCH_SUPPLIER_FACILITY_REQUEST,
    watchFetchSupplierFacilities,
  );
}

function* watchFetchSupplierFacilities() {
  try {
    const supplierFacilities: SupplierFacility[] = yield call(
      supplierSettingsService.supplierFacilities.list,
    );
    yield put(fetchSupplierFacilities.success({ supplierFacilities }));
  } catch (error) {
    yield put(fetchSupplierFacilities.error(error));
  }
}
